export const news = {
  GET_NEWS_REQUEST: "GET_NEWS_REQUEST",
  GET_NEWS_SUCCESS: "GET_NEWS_SUCCESS",
  GET_NEWS_FAILURE: "GET_NEWS_FAILURE",

  GET_SINGLE_NEW_REQUEST: "GET_SINGLE_NEW_REQUEST",
  GET_SINGLE_NEW_SUCCESS: "GET_SINGLE_NEW_SUCCESS",
  GET_SINGLE_NEW_FAILURE: "GET_SINGLE_NEW_FAILURE",
};

export const certificate = {
  GET_CERTIFICATE_REQUEST: "GET_CERTIFICATE_REQUEST",
  GET_CERTIFICATE_SUCCESS: "GET_CERTIFICATE_SUCCESS",
  GET_CERTIFICATE_FAILURE: "GET_CERTIFICATE_FAILURE",
};

export const magazine = {
  GET_MAGAZINE_REQUEST: "GET_MAGAZINE_REQUEST",
  GET_MAGAZINE_SUCCESS: "GET_MAGAZINE_SUCCESS",
  GET_MAGAZINE_FAILURE: "GET_MAGAZINE_FAILURE",
};

export const slider_home = {
  GET_SLIDER_REQUEST: "GET_SLIDER_REQUEST",
  GET_SLIDER_SUCCESS: "GET_SLIDER_SUCCESS",
  GET_SLIDER_FAILURE: "GET_SLIDER_FAILURE",
};

export const services = {
  GET_SERVICES_REQUEST: "GET_SERVICES_REQUEST",
  GET_SERVICES_SUCCESS: "GET_SERVICES_SUCCESS",
  GET_SERVICES_FAILURE: "GET_SERVICES_FAILURE",

  GET_SINGLE_SERVICES_REQUEST: "GET_SINGLE_SERVICES_REQUEST",
  GET_SINGLE_SERVICES_SUCCESS: "GET_SINGLE_SERVICES_SUCCESS",
  GET_SINGLE_SERVICES_FAILURE: "GET_SINGLE_SERVICES_FAILURE",
};

export const passengers = {
  GET_PASSENGERS_REQUEST: "GET_PASSENGERS_REQUEST",
  GET_PASSENGERS_SUCCESS: "GET_PASSENGERS_SUCCESS",
  GET_PASSENGERS_FAILURE: "GET_PASSENGERS_FAILURE",

  GET_SINGLE_PASSENGERS_REQUEST: "GET_SINGLE_PASSENGERS_REQUEST",
  GET_SINGLE_PASSENGERS_SUCCESS: "GET_SINGLE_PASSENGERS_SUCCESS",
  GET_SINGLE_PASSENGERS_FAILURE: "GET_SINGLE_PASSENGERS_FAILURE",
};

export const partner_home = {
  GET_PARTNER_HOME_REQUEST: "GET_PARTNER_HOME_REQUEST",
  GET_PARTNER_HOME_SUCCESS: "GET_PARTNER_HOME_SUCCESS",
  GET_PARTNER_HOME_FAILURE: "GET_PARTNER_HOME_FAILURE",

  GET_PARTNERS_REQUEST: "GET_PARTNERS_REQUEST",
  GET_PARTNERS_SUCCESS: "GET_PARTNERS_SUCCESS",
  GET_PARTNERS_FAILURE: "GET_PARTNERS_FAILURE",

  GET_SINGLE_PARTNERS_REQUEST: "GET_SINGLE_PARTNERS_REQUEST",
  GET_SINGLE_PARTNERS_SUCCESS: "GET_SINGLE_PARTNERS_SUCCESS",
  GET_SINGLE_PARTNERS_FAILURE: "GET_SINGLE_PARTNERS_FAILURE",
};

export const gallery = {
  GET_GALLERY_REQUEST: "GET_GALLERY_REQUEST",
  GET_GALLERY_SUCCESS: "GET_GALLERY_SUCCESS",
  GET_GALLERY_FAILURE: "GET_GALLERY_FAILURE",

  GET_VIDEO_REQUEST: "GET_VIDEO_REQUEST",
  GET_VIDEO_SUCCESS: "GET_VIDEO_SUCCESS",
  GET_VIDEO_FAILURE: "GET_VIDEO_FAILURE",

  GET_ALL_GALLERY_REQUEST: "GET_ALL_GALLERY_REQUEST",
  GET_ALL_GALLERY_SUCCESS: "GET_ALL_GALLERY_SUCCESS",
  GET_ALL_GALLERY_FAILURE: "GET_ALL_GALLERY_FAILURE",
};

export const flights = {
  GET_ARRIVAL_FLIGHTS_REQUEST: "GET_ARRIVAL_FLIGHTS_REQUEST",
  GET_ARRIVAL_FLIGHTS_SUCCESS: "GET_ARRIVAL_FLIGHTS_SUCCESS",
  GET_ARRIVAL_FLIGHTS_FAILURE: "GET_ARRIVAL_FLIGHTS_FAILURE",

  GET_DEPARTURE_FLIGHTS_REQUEST: "GET_DEPARTURE_FLIGHTS_REQUEST",
  GET_DEPARTURE_FLIGHTS_SUCCESS: "GET_DEPARTURE_FLIGHTS_SUCCESS",
  GET_DEPARTURE_FLIGHTS_FAILURE: "GET_DEPARTURE_FLIGHTS_FAILURE",
};
